/** Authenticated transport. No anonymous fallback, retry, or local credit refund. */
export async function medicationRequest(
  url: string, token: string | undefined, body: unknown,
  refresh: () => void | Promise<void>, transport: typeof fetch = fetch,
): Promise<Response> {
  if (!token) throw new Error('Sign in required');
  try {
    return await transport(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(body),
    });
  } finally {
    try { await refresh(); } catch { /* Preserve the original response/error. */ }
  }
}
